import en from './en.json';

export default function getTranslations() {
    return {
        en
    };
};
